import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { connect } from 'react-redux';
import Loading from '../../components/spinner';
import { withTranslation } from '../../lib/translate';
import { deepIsDefined, validateForm } from '../../lib/utils';
import { sendVoucherCode, checkDiscount, checkDiscountWithTaxes, showToast, setCommonProp, checkMultiBasketDiscountWithTaxes } from '../../store/actions';
import {
  Title,
  Spacer,
  NormalText,

  MediumText,
} from '../../components/common';

import Basket from '../../lib/basket';
import { getConfig } from '../../appConfig';
import './index.css';
import {  chevronForward } from 'ionicons/icons';
import moment from 'moment';

class ApplyVouchers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      discounts: null,
      selectedVoucher: null,
      showModal: null,
      voucherCode: '',
      disabledAppliedButton: false,
      formErrors: {
        voucherCode: '',
      },
    };
    this.formConfig = {
      voucherCode: { type: 'text', required: true },
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    if (Basket.tax_breakdown.length > 0) {
      if (Basket.has_multi_basket) {
        dispatch(checkMultiBasketDiscountWithTaxes(Basket.parseBasketForMultiBasketCheckVouchers(true)));
      } else {
        dispatch(checkDiscountWithTaxes(Basket.parseBasketForCheckVouchers(true)));
      }
    } else {
      if (Basket.has_multi_basket) {
        dispatch(checkMultiBasketDiscount(Basket.parseBasketForMultiBasketCheckVouchers()));
      } else {
        dispatch(checkDiscount(Basket.parseBasketForCheckVouchers()));
      }
    }

  }

  setVoucher = (voucher) => {
    this.setState({ selectedVoucher: voucher }, () => {
      const { vouchers, applicableVouchers } = this.props;
      const { selectedVoucher } = this.state;
      const appliedVoucher = vouchers.find((voucher) => voucher.id === selectedVoucher.id);
      const applicableVoucher = applicableVouchers.find(
        (appliableVoucher) => appliableVoucher.id === selectedVoucher.id,
      );
      if (Basket.canVoucherBeApplied(appliedVoucher, applicableVoucher)) {
        this.setState({ disabledAppliedButton: true });
        Basket.applyPoints(0);
      } else {
        this.setState({ disabledAppliedButton: false });
      }
    });
  };

  addVoucher = () => {
    const { selectedVoucher } = this.state;
    const { vouchers, applicableVouchers, dispatch, __ } = this.props;
    const appliedVoucher = vouchers.find((voucher) => voucher.id === selectedVoucher.id);
    const applicableVoucher = applicableVouchers.find(
      (appliableVoucher) => appliableVoucher.id === selectedVoucher.id,
    );
    if (Basket.canVoucherBeApplied(appliedVoucher, applicableVoucher)) {
      this.setState({ selectedVoucher: null }, () => {
        Basket.addVoucher(appliedVoucher, applicableVoucher);
        this.props.dispatch(setCommonProp('vouchersModalOpen', false))
      });
    } else {
      dispatch(
        showToast(
          __('Your basket is higher then voucher cost. Please add more items in basket'),
          'warning',
        ),
      );
    }
  };

  showModal = (show) => {
    this.setState({ showModal: show });
    this.clearFields();
  };

  clearFields = () => {
    this.setState({ voucherCode: '' });
  };

  sendCode = () => {
    const { dispatch, __ } = this.props;
    let formErrors = validateForm(this.formConfig, this.state, __);
    this.setState({ formErrors });
    if (Object.keys(formErrors).length === 0) {
      const { voucherCode } = this.state;
      const data = { code: voucherCode.toUpperCase() };
      this.clearFields();
      dispatch(sendVoucherCode(data));
      this.showModal(false);
    }
  };

  filterVouchers = (vouchers, appliedVouchers) => {
    const { applicableVouchers, availableBalance } = this.props;
    let filteredVouchers = [];
    if (applicableVouchers && applicableVouchers.length > 0) {
      applicableVouchers.forEach((discount) => {
        let findedVoucher = vouchers.find((voucher) => voucher.id === discount.id);
        if (getConfig().vouchersType === 2) {
          if (findedVoucher && availableBalance > findedVoucher.cost) {
            filteredVouchers.push(findedVoucher);
          }
        } else {
          if (findedVoucher) {
            filteredVouchers.push(findedVoucher);
          }
        }
      });
    }
    if (appliedVouchers && appliedVouchers.length > 0) {
      const ids = appliedVouchers.map((i) => i.id);
      return filteredVouchers.filter((filteredVoucher) => ids.indexOf(filteredVoucher.id) === -1);
    }
    return filteredVouchers;
  };
  render() {
    const { __, vouchers } = this.props;
    const { selectedVoucher, voucherCode, showModal, disabledAppliedButton } = this.state;
    const appliedVouchers = Basket ? Basket.applied_vouchers : [];
    const filteredVouchers = this.filterVouchers(vouchers, appliedVouchers);
    return (
      <Loading>
        <div className='vouchers-page-wrapper small-padding '>
          <div>
            <Title className="centered  large-title">{__('Select a voucher')}</Title>
          </div>

          <div className='box-with-gradient' style={{ width: '100%' }}>
            <div className="vouchers-wrapper">
              {filteredVouchers.map((voucher) => (
                <div
                  className={`${selectedVoucher && selectedVoucher.id === voucher.id ? 'voucher-selected' : ''
                    } box-content box-shadow`}
                  onClick={() => this.setVoucher(voucher)}
                >
                  <MediumText style={{ marginBottom: '10px' }} className="block primary-color">{voucher.reward.name}</MediumText>
                  <NormalText className="block ">
                    {`${__('Expires:')} ${moment(voucher.reward.expiry_date, 'YYYY/MM/DD').format(
                      'DD/MM/YY',
                    )}`}
                  </NormalText>
                </div>
              ))}
            </div>
          </div>
          <div>
            <IonButton
              disabled={!selectedVoucher}
              onClick={() => this.addVoucher()}
              className="large-button"
              color="primary"
            >
              {__('Continue')}
              <IonIcon slot='end'  icon={chevronForward} />
            </IonButton>
            <Spacer size={0} />

            <IonButton
              expand="block"
              onClick={() => this.props.dispatch(setCommonProp('vouchersModalOpen', false))}
              color="secondary"
              className="large-button"
            >
              {'Cancel'}
            </IonButton>
          </div>
        </div>
      </Loading>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    availableBalance: deepIsDefined(store, 'profile.profile.available_balance')
      ? store.profile.profile.available_balance
      : 0,
    basketUpadated: store.orders.basketUpdated,
    vouchers: store.profile.vouchers || null,
    applicableVouchers: store.profile.applicableVouchers || null,
  };
};

export default connect(mapStateToProps)(withTranslation(ApplyVouchers));
